import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { compose } from 'redux';
import { GetStaticProps } from 'next';
import {
  getEventDetailsById,
  getRunningQueriesThunk,
  useGetEventDetailsByIdQuery,
} from '../../../../services/events';
import { getStaticPropsWithRevalidate } from '../../../../utils/next/getStaticPropsWithRevalidate';
import { AppStore, wrapper } from '../../../../app/store';
import { ThankYou } from '../../../../components/outro/ThankYou';

type PageProps = { id: string };
type Params = PageProps;

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps = compose(
  getStaticPropsWithRevalidate(),
  wrapper.getStaticProps,
)(
  (store: AppStore): GetStaticProps<PageProps, Params> =>
    async ({ locale = 'en', params }) => {
      if (!params?.id) {
        return {
          notFound: true,
        };
      }

      await store.dispatch(getEventDetailsById.initiate(params.id));

      await Promise.all(store.dispatch(getRunningQueriesThunk()));

      return {
        props: {
          id: params.id,
          ...(await serverSideTranslations(locale, ['common', 'thank-you'])),
        },
      };
    },
);

export default function ThankYouPage({ id }: PageProps) {
  const { data } = useGetEventDetailsByIdQuery(id);
  const { t } = useTranslation('thank-you');

  return (
    <ThankYou
      id={id}
      logo={data?.team.logo}
      title={t('thankYou.title')}
      message={t('thankYou.message')}
      image={{ src: '/images/thank-you.svg', alt: 'Thank you logo' }}
    />
  );
}
